import { useTranslation } from "react-i18next";
import { PropertyData } from "../../interfaces/api/PropertyData";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { SwitchViewMode } from "../../shared/enums/SwitchViewMode";
import { castHelper } from "../../shared/helpers/castHelper";
import { productCardHelper } from "../../shared/helpers/productCardHelper";
import { localization } from "../../shared/helpers/productFilterHelper";
import { useMachineTonnage } from "../../store/hooks/useMachineTonnage";
import { useMarket } from "../../store/hooks/useMarket";
import ProductCard from "../ProductCard/ProductCard";
import "./Tiltrotators.scss";
import { getImageUrl } from "../../shared/helpers/getImageUrl";


interface TiltrotatorsProps {
  onTiltrotatorChange(rototilt: Rototilt): void;
  selectedTiltrotator: Rototilt;
  tiltrotators: Rototilt[];
}

const Tiltrotators = ({
  onTiltrotatorChange,
  selectedTiltrotator,
  tiltrotators,
}: TiltrotatorsProps) => {
  const market = useMarket();
  const machineTonnage = useMachineTonnage();
  const { t } = useTranslation(["metrics", "tiltrotator"]);

  if (!tiltrotators) {
    return <></>;
  }

  const isRecommended = (tiltrotatorName: string): boolean => {
    if (machineTonnage.switchViewMode === SwitchViewMode.MachineSearch) {
      return (
        machineTonnage.machineModel.recommendedRototilt.name === tiltrotatorName
      );
    }
    return false;
  };
 const getMarketValue = () => {
  if(market === "en-US")
  return "lb"
  else
  return "tonnes"
 }
  const getMachineWeight = (propertyData: PropertyData): string => {
    const value = Number(localization.value(propertyData, market));
    if(market === "en-US")
    return value.toString();
    else
    return castHelper.toTon(value).toString();
  };

  const isSelected = (tiltrotator: Rototilt): boolean => {
    if (!selectedTiltrotator) {
      return false;
    }
    return tiltrotator.name === selectedTiltrotator.name;
  };
//SORT TILTROTATORS TO HAVE RECOMENDED FIRST THEN RC THEN R
  tiltrotators.sort((a, b) => b.name.localeCompare(a.name));
  if (machineTonnage.switchViewMode === SwitchViewMode.MachineSearch) {
  tiltrotators.sort((a, b) => {
    const sortRecomended = [machineTonnage.machineModel.recommendedRototilt.name];
    const aname = sortRecomended.indexOf(a.name);
    const bname = sortRecomended.indexOf(b.name);
    return bname - aname;
  });
  }
  return (
    <div className="tiltrotators">
      {tiltrotators.map((tiltrotator) => {
        const isTiltrotatorRecommended = isRecommended(tiltrotator.name);
        return (

          <ProductCard
            key={tiltrotator.name}
            height={productCardHelper.height}
            content={`${getMachineWeight(
              tiltrotator.minimumMachineWeight
            )}-${getMachineWeight(tiltrotator.maximumMachineWeight)} ${t(getMarketValue()
              
            )}`}
            localImage={getImageUrl(tiltrotator)}
            isRecommended={isTiltrotatorRecommended}
            isSelected={isSelected(tiltrotator)}
            onChange={() => onTiltrotatorChange(tiltrotator)}
            preContent={
              isTiltrotatorRecommended
                ? t("recomended", { ns: "tiltrotator" })
                : ""
            }
            title={tiltrotator.name}
            addTooltip={false}
            tooltipText=""
          />
        );
      })}
    </div>
  );
};

export default Tiltrotators;
